import { Pipe, PipeTransform } from '@angular/core';
import {PROCESS_NAME, ProcessFriendlyNamesMap} from '@app/core/model/job.model';
import {JobManagementService} from '@app/core/service/job-management.service';

@Pipe({
    name: 'processFriendlyName'
})
export class ProcessFriendlyNamePipe implements PipeTransform {

    constructor(private jobManagementService: JobManagementService) { }

    transform(value: PROCESS_NAME, isTooltip: boolean = false): string {
        return this.jobManagementService.getProcessFriendlyName(value, isTooltip);
    }

}
